import { render, staticRenderFns } from "./OrganizationResponsibilitiesTab.vue?vue&type=template&id=22bff982&scoped=true"
import script from "./OrganizationResponsibilitiesTab.vue?vue&type=script&lang=js"
export * from "./OrganizationResponsibilitiesTab.vue?vue&type=script&lang=js"
import style0 from "./OrganizationResponsibilitiesTab.vue?vue&type=style&index=0&id=22bff982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bff982",
  null
  
)

export default component.exports